import { useState } from "react";
import { toast } from "sonner";
import { useApi, useFetch, useMe, errMsg, fmtDay } from "../lib/api";
import { Btn, Card, Empty, ExportButtons, PageHeader, Sel } from "../components/common";

const ROLES = ["CTO", "CIO", "IT Director", "Head of Engineering", "Database Manager", "Hiring Manager", "Technical Recruiter", "Partnerships Manager", "Founder", "Listed contact (from public posting)"];

export function ContactForm({ companyId, onSaved }) {
  const api = useApi();
  const blank = { name: "", role: "CTO", email: "", phone: "", linkedin: "", source_url: "", confidence: "medium", basis: "" };
  const [f, setF] = useState(blank);
  const set = (k) => (e) => setF({ ...f, [k]: e?.target ? e.target.value : e });
  const save = async () => {
    try { await api.post("/contacts", { ...f, company_id: companyId }); toast.success("Contact saved"); setF(blank); onSaved(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mt-4 rounded-md border border-dashed border-slate-300 p-3" data-testid="contact-form">
      <div className="mb-2 text-xs font-semibold text-slate-600">Add publicly listed business contact — source link is mandatory</div>
      <div className="grid gap-2 md:grid-cols-4">
        <input data-testid="contact-name" className="dm-input" placeholder="Name (as published)" value={f.name} onChange={set("name")} />
        <Sel testid="contact-role" value={f.role} onChange={set("role")} options={ROLES} />
        <input data-testid="contact-email" className="dm-input" placeholder="Business email (as published)" value={f.email} onChange={set("email")} />
        <input data-testid="contact-phone" className="dm-input" placeholder="Business phone (encrypted)" value={f.phone} onChange={set("phone")} />
        <input data-testid="contact-linkedin" className="dm-input" placeholder="Public LinkedIn URL" value={f.linkedin} onChange={set("linkedin")} />
        <input data-testid="contact-source" className="dm-input md:col-span-2" placeholder="Source URL where this was published *" value={f.source_url} onChange={set("source_url")} />
        <Sel testid="contact-confidence" value={f.confidence} onChange={set("confidence")} options={["high", "medium", "low"]} />
        <input data-testid="contact-basis" className="dm-input md:col-span-3" placeholder="Basis (e.g. 'Listed on company leadership page')" value={f.basis} onChange={set("basis")} />
        <Btn data-testid="contact-save" onClick={save} disabled={!f.source_url || (!f.email && !f.name)}>Save contact</Btn>
      </div>
    </div>
  );
}

export default function Contacts() {
  const [q, setQ] = useState("");
  const api = useApi();
  const { isAdmin } = useMe();
  const { data, reload } = useFetch(`/contacts?q=${encodeURIComponent(q)}`);
  const del = async (id) => { try { await api.del(`/contacts/${id}`); reload(); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div>
      <PageHeader title="Contacts" subtitle="Only publicly listed business contacts with a recorded source and confidence. Names, emails and numbers are never generated.">
        <ExportButtons rows={data} name="contacts" />
      </PageHeader>
      <input data-testid="contacts-search" className="dm-input mb-4 w-72" placeholder="Search…" value={q} onChange={(e) => setQ(e.target.value)} />
      <Card>
        {!data?.length ? <Empty text="No contacts yet. Contacts are added from public postings or manually from a company page." testid="contacts-empty" /> : (
          <div className="overflow-x-auto"><table className="dm-table w-full">
            <thead><tr><th>Name</th><th>Role</th><th>Company</th><th>Email</th><th>Phone</th><th>Confidence</th><th>Basis / source</th><th>Added</th><th></th></tr></thead>
            <tbody>{data.map((c) => (
              <tr key={c.id} data-testid={`contact-row-${c.id}`}>
                <td>{c.name || <span className="text-slate-400">not published</span>}</td><td className="text-xs">{c.role}</td><td className="text-sm">{c.company}</td>
                <td className="font-mono text-xs">{c.email}</td><td className="font-mono text-xs">{c.phone}</td><td className="text-xs">{c.confidence}</td>
                <td className="max-w-xs text-xs">{c.basis} <a href={c.source_url} target="_blank" rel="noreferrer" className="text-blue-700 hover:underline">link</a></td>
                <td className="text-xs">{fmtDay(c.created_at)}</td>
                <td>{isAdmin && <button data-testid={`contact-delete-${c.id}`} className="text-xs text-red-600 hover:underline" onClick={() => del(c.id)}>Delete</button>}</td>
              </tr>))}</tbody>
          </table></div>)}
      </Card>
    </div>
  );
}
